<template>
  <div>
    <MainHeader />

    <Factsheets v-if="init && (profile)" />

    <div v-else>
      Please log in to see an overview of your projects and factsheets.
    </div>

    <Footer />
  </div>
</template>

<script>
  import MainHeader from '@/components/generic/MainHeader.vue'
  import SubHeader from '@/components/factsheet/SubHeader.vue'
  import Footer from '@/components/generic/Footer.vue'

  import Factsheets from '@/components/home/user/Factsheets.vue'

  import Leader from '@/components/home/Leader.vue'
  import Teaser from '@/components/home/Teaser.vue'
  import Accreditation from '@/components/home/Accreditation.vue'

  export default {
    name: 'home',
    components: {
      Leader, Teaser, Accreditation, MainHeader, Footer, Factsheets
    },
    computed: {
        profile() {
            return this.$store.state.profile
        },
        init() {
          return this.$store.state.init
        }
    }
  }
</script>

<style scoped>
    div.container {
        background-color:#eee;
    }


 
</style>
